// src/pages/programs/JobOrders.jsx
import React from "react";
import { useParams } from "react-router-dom";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import useGetProgram from "../../hooks/programs/useGetProgram";
import LoadingPage from "../../components/global/LoadingPage";
import WrapperSection from "../../components/global/WrapperSection";
import ProgramHeader from "../../components/programs/ShowProgram/ProgramHeader";
import JobOrdersList from "../../components/programs/JobOrders/JobOrdersList";

const JobOrders = () => {
    const { id } = useParams();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === 'ar';

    const { program, isLoading, error } = useGetProgram(id);

    if (isLoading) return <LoadingPage />;
    if (error || !program) {
        return (
            <Box p={3} sx={{ textAlign: "center", color: "error.main" }}>
                <Typography>{isArabic ? "حدث خطأ أثناء تحميل البرنامج" : "Error loading program"}</Typography>
            </Box>
        );
    }

    return (
        <Box>
            {/* Header & Breadcrumbs */}
            <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
                <GlobalBreadcrumbs customTitle={isArabic ? "أوامر التشغيل والفاوتشر" : "Job Orders & Vouchers"} />
                <Typography variant="h4" fontWeight="bold" sx={{ mt: 2 }}>
                    {isArabic ? "أوامر التشغيل والفاوتشر" : "Job Orders & Vouchers"}
                </Typography>
            </Container>

            <Container maxWidth="xl" sx={{ pb: 6 }}>
                <WrapperSection
                    title={isArabic ? "معلومات البرنامج" : "Program Information"}
                    disableMargin
                    sx={{ mb: 4, overflow: "hidden" }}
                >
                    <ProgramHeader program={program} />
                </WrapperSection>

                <WrapperSection
                    title={isArabic ? "قائمة أوامر التشغيل والفاوتشر" : "Job Orders & Vouchers List"}
                    disableMargin
                    sx={{ mb: 4, overflow: "hidden" }}
                >
                    <JobOrdersList program={program} />
                </WrapperSection>
            </Container>
        </Box>
    );
};

export default JobOrders;
